// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// initial states
const initialState = {};

export const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {},
});

export const {} = notificationSlice.actions;

export default notificationSlice.reducer;
